module.exports = __webpack_public_path__ + "img/anniu1.c388b02a.png";